import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { CommonConstants } from "@src/define/common";
import { HOSTNAME, isExternalUrl } from "@src/utils";

import QuickButton from "./QuickButton";

const { DisplayWeddingHallQuickButtonPaths, DisplaySdmQuickButtonPaths } = CommonConstants;

export default function AppQuickButtonContainer() {
  const { pathname } = useLocation();

  const [quickButtonMode, setQuickButtonMode] = useState<"weddinghall" | "sdm" | null>(null);

  useEffect(() => {
    const isWeddingHallQuickButton = DisplayWeddingHallQuickButtonPaths.some(
      (path) => path === pathname,
    );
    if (isWeddingHallQuickButton) {
      setQuickButtonMode("weddinghall");
      return;
    }

    const isSdmQuickButton = DisplaySdmQuickButtonPaths.some((path) => path === pathname);
    if (isSdmQuickButton) {
      setQuickButtonMode("sdm");
      return;
    }

    setQuickButtonMode(null);
  }, [pathname]);

  return (
    <>
      {quickButtonMode === "weddinghall" && <QuickButton text="빠른 문의" buttonWidth={115} />}
      {quickButtonMode === "sdm" && (
        <QuickButton
          text="스드메 빠른 문의"
          buttonWidth={163}
          customOnClick={() => {
            const link = isExternalUrl(
              `${HOSTNAME}/consulting/info?wbTitle=%20&uncontact=1&funnel=&hidetop=true`,
            );
            window.location.href = link;
          }}
        />
      )}
    </>
  );
}
